export default __webpack_public_path__ + "static/media/Jda.61a70ea8.png";